import React from 'react';

import propTypes from 'prop-types';

export default class QuantityLimit extends React.Component {
  static propTypes = {
    isMembershipOrder: propTypes.bool.isRequired,
    subscriptionLimit: propTypes.number.isRequired,
    singleOrderLimit: propTypes.number.isRequired,
  };

  render() {
    const {
      isMembershipOrder,
      subscriptionLimit,
      singleOrderLimit,
    } = this.props;

    const displayLimit = isMembershipOrder
      ? subscriptionLimit
      : singleOrderLimit;
    return <span>{displayLimit}</span>;
  }
}
